export const createDeferred = loader => {
  let resolve;
  const deferred = {
    promise: new Promise(res => {
      resolve = m => {
        let withDefault;
        deferred.result = m;

        if (!m.default) {
          withDefault = {
            default: m
          };
        }

        res(withDefault ? withDefault : m);
      };
    }),
    result: undefined,
    start: () => loader().then(resolve)
  };
  return deferred;
};